module.exports = __webpack_public_path__ + "45e4891e7c8552e04ac1cd6d3df0c00f.svg";